import { render, staticRenderFns } from "./PortalTimeline.vue?vue&type=template&id=05317444&scoped=true&"
import script from "./PortalTimeline.vue?vue&type=script&lang=js&"
export * from "./PortalTimeline.vue?vue&type=script&lang=js&"
import style0 from "./PortalTimeline.vue?vue&type=style&index=0&id=05317444&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05317444",
  null
  
)

export default component.exports